import { styled, TextV1 } from '@withjoy/joykit';

export const StyledText = styled(TextV1)`
  font-family: 'Akkurat LL';
  font-size: 24px;
  font-style: normal;
  font-weight: bold;
  line-height: 29px;
  letter-spacing: 0.005em;
  color: ${props => props.theme.colors.mono14};

  @media screen and (max-width: 425px) {
    line-height: 36px;
  }
`;
